<script setup lang="ts">
import { ref } from 'vue';
import BaseModal from '@/components/modal/BaseModal.vue';
import ModalFooterConfirmButtons from '@/components/modal/ModalFooterConfirmButtons.vue';
import type { ReturnApplicationModalProps } from '@/stores/modal';
import { MODAL_TYPES, useModalStore } from '@/stores/modal';

const props = defineProps<ReturnApplicationModalProps>();
const modalStore = useModalStore();

const isSubmitting = ref(false);

const handleClose = () => {
  modalStore.close(MODAL_TYPES.RETURN_APPLICATION);
};

const handleConfirm = async () => {
  if (isSubmitting.value) return;

  try {
    isSubmitting.value = true;
    await props.onConfirm({
      absenceId: props.absenceId,
    });
    handleClose();
  }
  finally {
    isSubmitting.value = false;
  }
};
</script>

<template>
  <BaseModal title="복귀서 제출하기" width="420px" aria-label="복귀서 제출" @close="handleClose">
    <div class="flex flex-col gap-5 px-1 py-2">
      <div class="rounded-[12px] bg-[#fff8f3] border border-[#fde8d9] p-4 text-[14px] leading-[1.6] text-[#7d6250]">
        <p class="font-[800] text-[#2f241c] mb-1.5 flex items-center gap-1.5 text-[15px]">
          ⚠️ 복귀 일자 및 처리 안내
        </p>
        <p>복귀 처리는 제출 완료 시점인 <span class="font-[800] text-[#ee8544]">오늘 날짜</span>로 즉시 반영됩니다.</p>
        <p v-if="props.expectedReturnDate" class="mt-2 text-[13px] text-[#9a7e6b] border-t border-[#f7e0d0] pt-2">
          (기존 복귀 예정일: {{ props.expectedReturnDate }})
        </p>
      </div>
      <p class="text-[15px] font-[500] leading-[1.6] text-[#2f241c] text-center my-2">
        복귀 신청을 완료하고 소임 활동으로 복귀하시겠습니까?
      </p>
    </div>

    <template #footer>
      <ModalFooterConfirmButtons
        cancel-text="취소"
        confirm-text="복귀 완료"
        :disabled="isSubmitting"
        :is-loading="isSubmitting"
        @cancel="handleClose"
        @confirm="handleConfirm"
      />
    </template>
  </BaseModal>
</template>
